import KeyboardArrowDownRoundedIcon from '@mui/icons-material/KeyboardArrowDownRounded';
import { Box, MenuItem, Select, SxProps, Theme } from '@mui/material';
import type { ReactNode } from 'react';
import { StyleObj } from '../../../../@types';
import { mergeSx } from '../../../../utils/styles';

const styles: StyleObj = {
  menu: {
    '& .MuiPaper-root': {
      width: {
        xs: 100,
        md: 120,
      },
      '& .MuiList-root': {
        paddingTop: 0,
        paddingBottom: 0,
        '& > li': {
          typography: 'body3',
          padding: 1,
        },
        '& .MuiButtonBase-root': {
          minHeight: 0,
        },
      },
    },
  },
  select: {
    width: '100%',
    minWidth: 0,
    maxWidth: '100%',
    backgroundColor: 'neutral.600',
    borderRadius: 1.5,
    '.MuiSelect-select': {
      pl: 0.75,
    },
  },
  triggerValue: {
    display: 'flex',
    alignItems: 'center',
    gap: 0.75,
    minWidth: 0,
    width: '100%',
    pr: 0.25,
  },
  triggerLabel: {
    minWidth: 0,
    flex: 1,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
};

type NeobetBetslipMenuProps = {
  selectedMenuItem: string;
  onChange: (value: string) => void;
  options: { label: string; value: string }[] | undefined;
  disabledOptions?: string[] | undefined;
  sx?: SxProps<Theme>;
  menuSx?: SxProps<Theme>;
  disabled?: boolean;
  ariaLabel?: string;
  renderValue?: (selectedValue: string) => ReactNode;
};

const NeobetBetslipMenu = ({
  selectedMenuItem,
  onChange,
  options,
  disabledOptions,
  sx,
  menuSx,
  disabled,
  ariaLabel,
  renderValue,
}: NeobetBetslipMenuProps) => {
  return (
    <Select
      value={selectedMenuItem}
      onChange={(e) => {
        onChange(e.target.value as string);
      }}
      IconComponent={KeyboardArrowDownRoundedIcon}
      sx={mergeSx(styles.select, sx)}
      renderValue={renderValue}
      MenuProps={{
        sx: mergeSx(styles.menu, menuSx),
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'right',
        },
        transformOrigin: {
          vertical: 'top',
          horizontal: 'right',
        },
      }}
      disabled={disabled}
      inputProps={ariaLabel ? { 'aria-label': ariaLabel } : undefined}
    >
      {options?.map((option) => (
        <MenuItem key={option.value} value={option.value} disabled={disabledOptions?.includes(option.value) || false}>
          {option.label}
        </MenuItem>
      ))}
    </Select>
  );
};

export default NeobetBetslipMenu;

export const NeobetBetslipMenuTriggerValue = ({
  icon,
  label,
  children,
}: {
  icon: ReactNode;
  label: string;
  children?: ReactNode;
}) => (
  <Box sx={styles.triggerValue}>
    {icon}
    <Box component='span' sx={styles.triggerLabel}>
      {label}
    </Box>
    {children}
  </Box>
);
